export const AW_USER_PREFERENCES_API_URL = process.env?.AWAPI_AWUSERPREFERENCESERVER_URL || '/awuserpreference/api';
export const AW_USER_PREFERENCES_API_URL_AGRAPH =
  process.env?.AWAPI_AWUSERPREFERENCESERVER_URL_AGRAPH || '/api/wealth/legacy/aw-userpref';
